import {createContext, useContext} from "react";

export const MenuCollapsedContext = createContext<boolean>(false);

export const useMenuCollapsed = (): boolean => useContext(MenuCollapsedContext);
